import ApiService from '../../components/api_services/apiService.jsx';

const defaultPayload = {
  userActivity: {
    dailyActiveUsers: 0,
    weeklyActiveUsers: 0,
    monthlyActiveUsers: 0,
  },
  userCounts: {
    totalUsers: 0,
    newUsersLastWeek: 0,
    newUsersLastMonth: 0,
  },
  premium: {
    premiumUsers: 0,
    nonPremiumUsers: 0,
    conversionCohort30Days: 0,
    convertedToPremium30Days: 0,
    conversionRatePercent30Days: 0,
  },
  revenue: {
    revenueByCurrency: {},
    midLtv: 0,
    estimatedClientEarnings: 0,
    estimatedCost: 0,
  },
  vehicleCheck: {
    initialChecksCount: 0,
    finalizingChecksCount: 0,
    percentCompleted: 0,
    averageDaysToFinalization: null,
  },
  notesAndDocuments: {
    averageDailyNotes: 0,
    summariesByCategory: [],
    summariesByMonth: [],
    averageDocumentsPerUserPerMonth: 0,
    averageDocumentsPerTypePerMonth: {},
  },
  timesheets: {
    totalEntries: 0,
    pendingEntries: 0,
    rejectedEntries: 0,
    percentFavourable: 0,
    percentUsersAddingEntries: 0,
  },
  engagement: {
    usersWithNotificationsEnabled: 0,
    percentUsersReactingToNotifications: 0,
  },
};

export const fetchAdminStatistics = async (setData, setLoading, setError) => {
  setLoading(true);
  setError(null);
  try {
    const data = await ApiService.getAdminStatistics();
    setData(data || defaultPayload);
  } catch (err) {
    setError(err?.message || 'Błąd ładowania statystyk');
    setData(defaultPayload);
  } finally {
    setLoading(false);
  }
};

export { defaultPayload };
